module.exports = __webpack_public_path__ + "img/UI_common_framelabelFX_02_6862a0551.png";